import React from 'react';
import PropTypes from 'prop-types';
import { UnmountClosed } from 'react-collapse';
import { presets } from 'react-motion';

import RadioButton from '@style-guide/components/RadioButton';

import Arrow from './shared/Arrow';
import Body from './shared/Body';
import Header from './shared/Header';
import Title from './shared/Title';
import Wrapper from './shared/Wrapper';

class EventFormatFilter extends React.Component {
  constructor() {
    super();

    this.state = {
      isOpened: true,
    };

    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse() {
    this.setState(prevState => ({
      isOpened: !prevState.isOpened,
    }));
  }

  render() {
    const {
      filterValue,
      filterOptions,
      filterUpdate,
    } = this.props;
    const {
      isOpened,
    } = this.state;

    return (
      <Wrapper>
        <Header
          onClick={this.toggleCollapse}
          $isOpened={isOpened}
          id="eventFormatFilterCollapseToggle"
        >
          <Title>Event Format</Title>
          <Arrow isOpened={isOpened} />
        </Header>
        <UnmountClosed
          presets={presets.gentle}
          isOpened={isOpened}
        >
          <Body
            id="filterEventFormatWrapper"
          >
            <RadioButton
              label="All Formats"
              value="All Formats"
              onChange={() => filterUpdate('eventFormat', null)}
              id="filterEventFormatOptionAll"
              isChecked={filterValue === null}
              name="All Formats"
            />
            {filterOptions.map((item) => {
              const onChangeHandler = () => filterUpdate('eventFormat', {
                filterId: item.filterId,
                filterName: item.filterName,
              });

              return (
                <RadioButton
                  key={item.filterId}
                  label={item.filterName}
                  value={item.filterName}
                  onChange={onChangeHandler}
                  id={`filterEventFormatOption${item.filterId}`}
                  isChecked={filterValue === null ? false : filterValue.filterId === item.filterId}
                  name={item.filterName}
                />
              );
            })}
          </Body>
        </UnmountClosed>
      </Wrapper>
    );
  }
}

EventFormatFilter.propTypes = {
  filterUpdate: PropTypes.func.isRequired,
  filterOptions: PropTypes.arrayOf(PropTypes.object),
  filterValue: PropTypes.shape({
    filterId: PropTypes.string,
    filterName: PropTypes.string,
  }),
};

EventFormatFilter.defaultProps = {
  filterValue: null,
  filterOptions: [],
};

EventFormatFilter.displayName = 'EventFormatFilter';

export default EventFormatFilter;
